/**
 * Event constants class, contains event name strings and keyboard event key names.
 */
export abstract class EventConstants {

	public static readonly blur = "blur";
	public static readonly change = "change";
	public static readonly click = "click";
	public static readonly focus = "focus";
	public static readonly input = "input";
	public static readonly keydown = "keydown";
	public static readonly none = "none";

	public static readonly blur_ipf = "blur.ipf";
	public static readonly change_ipf = "change.ipf";
	public static readonly click_ipf = "click.ipf";
	public static readonly input_ipf = "input.ipf";
	public static readonly keydown_ipf = "keydown.ipf";
	public static readonly paste_ipf = "paste.ipf";

	public static readonly change_ipfvalidator = "change.ipfvalidator";

	public static readonly change_ipffilter = "change.ipffilter";

	public static readonly input_ipfnumericformat = "input.ipfnumericformat";
	public static readonly blur_ipfnumericformat = "blur.ipfnumericformat";

	public static readonly key_backspace = "Backspace";
	public static readonly key_delete = "Delete";
	public static readonly key_enter = "Enter";
	public static readonly key_tab = "Tab";
}